// extracted by mini-css-extract-plugin
export default {"wrapper":"SiteFooter_wrapper__2b+hy"};